import HomeIcon from '@/assets/images/actionToolbar/home.svg';
import styles from './homeButton.module.scss';
import { useRouter } from 'next/navigation';

export default function HomeButton() {
  const router = useRouter();
  return (
    <button
      className={styles.homeButton}
      onClick={() => router.push('/interactive-map')}
    >
      <HomeIcon />
    </button>
  );
}
